/**
 * assets/pdp-v3.js
 * Handles interactivity for the Product Template v3 (SNS bundle builder).
 */
(function () {
  'use strict';

  function formatMoney(cents, moneyFormat) {
    var amount = (cents / 100).toFixed(2);
    if (moneyFormat) return moneyFormat.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100));
    return '\u00A3' + amount;
  }

  function initPdpV3(infoEl) {
    var moneyFormat = infoEl.dataset.moneyFormat || null;
    var currentType = infoEl.dataset.initialType || 'onetime';

    // ── Purchase type toggle ──────────────────────────────────────────────────
    var typeBtns = infoEl.querySelectorAll('.pdp-v3__type-btn');
    var benefitsPanel = infoEl.querySelector('.pdp-v3__sns-benefits');
    var subBtn = infoEl.querySelector('.pdp-v3__type-btn[data-type="subscription"]');
    var otpBtn = infoEl.querySelector('.pdp-v3__type-btn[data-type="onetime"]');
    var unitPriceEl = infoEl.querySelector('.pdp-v3__unit-price');

    function setType(type) {
      currentType = type;

      typeBtns.forEach(function (btn) {
        var active = btn.dataset.type === type;
        btn.style.backgroundColor = active ? '#e5d8c8' : 'white';
        var filledRadio = btn.querySelector('.pdp-v3__type-radio-filled');
        var emptyRadio = btn.querySelector('.pdp-v3__type-radio-empty');
        if (filledRadio) filledRadio.classList.toggle('hidden', !active);
        if (emptyRadio) emptyRadio.classList.toggle('hidden', active);
      });

      // Update unit price bullet
      if (unitPriceEl) {
        var isSub = type === 'subscription';
        var snsPrice = unitPriceEl.dataset.snsPrice;
        var otpPrice = unitPriceEl.dataset.otpPrice;
        unitPriceEl.textContent = (isSub && snsPrice) ? snsPrice : otpPrice;
      }

      // Show/hide benefits panel and update tab rounding + borders
      if (benefitsPanel) {
        var showBenefits = type === 'subscription';
        benefitsPanel.classList.toggle('hidden', !showBenefits);

        // Sub (left) tab: no bottom border or bottom-left radius when benefits shown
        if (subBtn) {
          subBtn.style.borderBottomWidth = showBenefits ? '0' : '';
          subBtn.style.borderRadius = showBenefits ? '6px 0 0 0' : '6px 0 0 6px';
        }
        if (otpBtn) {
          otpBtn.style.borderRadius = showBenefits ? '0 6px 0 0' : '0 6px 6px 0';
        }
      }

      updateCta();
    }

    typeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setType(btn.dataset.type);
      });
    });

    // ── Stepper ───────────────────────────────────────────────────────────────
    var rows = infoEl.querySelectorAll('.pdp-v3__flavour-row');

    function updateRowStyle(row) {
      var qtyEl = row.querySelector('.pdp-v3__row-qty');
      if (!qtyEl) return;
      var minusBtn = row.querySelector('.pdp-v3__row-minus');
      var plusBtn = row.querySelector('.pdp-v3__row-plus');
      var qty = parseInt(qtyEl.textContent, 10) || 0;
      var active = qty > 0;

      if (row.dataset.isCurrent === 'true') {
        row.style.backgroundColor = 'rgba(222,206,186,0.2)';
      }

      [minusBtn, plusBtn].forEach(function (btn) {
        if (!btn) return;
        btn.style.backgroundColor = active ? 'rgba(229,216,200,0.8)' : 'white';
        btn.style.borderColor = '#e5d8c8';
      });

      if (minusBtn) minusBtn.style.display = qty <= 0 ? 'none' : '';
    }

    rows.forEach(function (row) {
      var step = parseInt(row.dataset.step, 10) || 1;
      var qtyEl = row.querySelector('.pdp-v3__row-qty');
      var minusBtn = row.querySelector('.pdp-v3__row-minus');
      var plusBtn = row.querySelector('.pdp-v3__row-plus');

      if (!qtyEl || !plusBtn) return;

      plusBtn.addEventListener('click', function () {
        var qty = parseInt(qtyEl.textContent, 10) || 0;
        qtyEl.textContent = qty + step;
        updateRowStyle(row);
        updateTotal();
        updateCta();
      });

      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          var qty = parseInt(qtyEl.textContent, 10) || 0;
          if (qty <= 0) return;
          qtyEl.textContent = Math.max(0, qty - step);
          updateRowStyle(row);
          updateTotal();
          updateCta();
        });
      }
    });

    // ── Total badge ───────────────────────────────────────────────────────────
    var totalCountEl = infoEl.querySelector('.pdp-v3__total-count');
    var totalLabelEl = infoEl.querySelector('.pdp-v3__total-label');

    function updateTotal() {
      var total = 0;
      rows.forEach(function (row) {
        var qtyEl = row.querySelector('.pdp-v3__row-qty');
        total += parseInt(qtyEl ? qtyEl.textContent : 0, 10) || 0;
      });
      if (totalCountEl) totalCountEl.textContent = total;
      if (totalLabelEl) {
        totalLabelEl.textContent = total === 1
          ? (totalLabelEl.dataset.singular || totalLabelEl.dataset.plural)
          : totalLabelEl.dataset.plural;
      }
      return total;
    }

    // ── CTA prices ────────────────────────────────────────────────────────────
    var atcOtpPriceEl = infoEl.querySelector('.pdp-v3__atc-otp-price');
    var atcSnsPriceEl = infoEl.querySelector('.pdp-v3__atc-sns-price');
    var atcPriceEl = infoEl.querySelector('.pdp-v3__atc-price');
    var atcLabelEl = infoEl.querySelector('.pdp-v3__atc-label');
    var atcPipeEl = infoEl.querySelector('.pdp-v3__atc-pipe');

    function updateCta() {
      var otpTotal = 0;
      var snsTotal = 0;
      var rrpTotal = 0;
      var totalQty = 0;

      rows.forEach(function (row) {
        var qty = parseInt(row.querySelector('.pdp-v3__row-qty') ? row.querySelector('.pdp-v3__row-qty').textContent : 0, 10) || 0;
        var step = parseInt(row.dataset.step, 10) || 1;
        var packs = qty / step;
        var price = parseInt(row.dataset.price, 10) || 0;
        var snsPrice = parseInt(row.dataset.snsPrice, 10) || 0;
        var rrp = parseInt(row.dataset.rrp, 10) || 0;
        otpTotal += packs * price;
        snsTotal += packs * (snsPrice || price);
        rrpTotal += packs * rrp;
        totalQty += qty;
      });

      var isEmpty = totalQty === 0;
      if (atcBtn) atcBtn.style.opacity = isEmpty ? '0.4' : '1';
      if (atcPipeEl) atcPipeEl.style.display = isEmpty ? 'none' : '';
      if (isEmpty) {
        if (atcLabelEl) atcLabelEl.textContent = atcBtn && atcBtn.dataset.oos === 'true' ? 'Out of Stock' : 'Add an item to continue';
        if (atcOtpPriceEl) atcOtpPriceEl.style.display = 'none';
        if (atcSnsPriceEl) atcSnsPriceEl.style.display = 'none';
        if (atcPriceEl) atcPriceEl.style.display = 'none';
        return;
      }

      var isSub = currentType === 'subscription';
      var label = isSub ? 'SUBSCRIBE' : 'ADD TO CART';

      if (atcLabelEl) atcLabelEl.textContent = label;

      if (isSub && snsTotal > 0 && snsTotal !== otpTotal) {
        // Subscription: strikethrough OTP + SNS discounted price
        if (atcOtpPriceEl) { atcOtpPriceEl.textContent = formatMoney(otpTotal, moneyFormat); atcOtpPriceEl.style.display = ''; }
        if (atcSnsPriceEl) { atcSnsPriceEl.textContent = formatMoney(snsTotal, moneyFormat); atcSnsPriceEl.style.display = ''; }
        if (atcPriceEl) atcPriceEl.style.display = 'none';
      } else if (!isSub && rrpTotal > 0) {
        // OTP with RRP: strikethrough RRP + actual price
        if (atcOtpPriceEl) { atcOtpPriceEl.textContent = formatMoney(rrpTotal, moneyFormat); atcOtpPriceEl.style.display = ''; }
        if (atcSnsPriceEl) atcSnsPriceEl.style.display = 'none';
        if (atcPriceEl) { atcPriceEl.textContent = formatMoney(otpTotal, moneyFormat); atcPriceEl.style.display = ''; }
      } else {
        if (atcOtpPriceEl) atcOtpPriceEl.style.display = 'none';
        if (atcSnsPriceEl) atcSnsPriceEl.style.display = 'none';
        var displayPrice = isSub ? snsTotal : otpTotal;
        if (atcPriceEl) {
          atcPriceEl.textContent = displayPrice > 0 ? formatMoney(displayPrice, moneyFormat) : '';
          atcPriceEl.style.display = displayPrice > 0 ? '' : 'none';
        }
      }
    }

    // ── Accordions ────────────────────────────────────────────────────────────
    var accordionTriggers = infoEl.querySelectorAll('.pdp-v3__accordion-trigger');
    accordionTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var body = trigger.nextElementSibling;
        if (!body) return;
        var isOpen = !body.classList.contains('hidden');
        body.classList.toggle('hidden', isOpen);
        trigger.setAttribute('aria-expanded', String(!isOpen));
        var arrow = trigger.querySelector('.pdp-v3__accordion-arrow');
        if (arrow) arrow.style.transform = isOpen ? '' : 'rotate(180deg)';
      });
    });

    // ── Add to cart ───────────────────────────────────────────────────────────
    var atcBtn = infoEl.querySelector('.pdp-v3__atc');
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        var items = [];
        rows.forEach(function (row) {
          var qtyEl = row.querySelector('.pdp-v3__row-qty');
          var qty = parseInt(qtyEl ? qtyEl.textContent : 0, 10) || 0;
          if (qty <= 0) return;
          var step = parseInt(row.dataset.step, 10) || 1;
          var variantId = parseInt(row.dataset.variantId, 10);
          var sellingPlan = row.dataset.sellingPlan;
          var item = { id: variantId, quantity: qty / step };
          if (currentType === 'subscription' && sellingPlan) {
            item.selling_plan = parseInt(sellingPlan, 10);
          }
          items.push(item);
        });

        if (items.length === 0) return;

        atcBtn.disabled = true;
        var originalLabel = atcLabelEl ? atcLabelEl.textContent : '';
        if (atcLabelEl) atcLabelEl.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) {
              var msg = res.data.description || 'Something went wrong — please try again';
              if (atcLabelEl) atcLabelEl.textContent = msg;
              atcBtn.disabled = false;
              setTimeout(function () {
                if (atcLabelEl) atcLabelEl.textContent = originalLabel;
              }, 4000);
              return;
            }
            window.location.href = '/cart';
          })
          .catch(function (err) {
            console.error('[pdp-v3] Add to cart error:', err);
            if (atcLabelEl) atcLabelEl.textContent = 'Something went wrong — please try again';
            atcBtn.disabled = false;
            setTimeout(function () {
              if (atcLabelEl) atcLabelEl.textContent = originalLabel;
            }, 4000);
          });
      });
    }

    // ── Learn more modal ──────────────────────────────────────────────────────
    var learnMoreOverlay = infoEl.querySelector('.pdp-v3__learn-more-overlay');
    var learnMoreBody = learnMoreOverlay ? learnMoreOverlay.querySelector('.pdp-v3__learn-more-body') : null;
    var learnMoreClose = learnMoreOverlay ? learnMoreOverlay.querySelector('.pdp-v3__learn-more-close') : null;
    var learnMoreTriggerBtn = null;

    function closeLearnMore() {
      if (learnMoreOverlay) learnMoreOverlay.classList.add('hidden');
      document.body.style.overflow = '';
      if (learnMoreTriggerBtn) learnMoreTriggerBtn.focus();
      learnMoreTriggerBtn = null;
    }

    function trapFocus(e) {
      if (!learnMoreOverlay || learnMoreOverlay.classList.contains('hidden')) return;
      var focusable = learnMoreOverlay.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }
    }

    infoEl.querySelectorAll('.pdp-v3__learn-more-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var productId = btn.dataset.productId;
        var content = infoEl.querySelector('.pdp-v3__learn-more-content[data-product-id="' + productId + '"]');
        if (!content || !learnMoreOverlay || !learnMoreBody) return;
        learnMoreTriggerBtn = btn;
        learnMoreBody.innerHTML = content.innerHTML;
        learnMoreOverlay.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
        if (learnMoreClose) learnMoreClose.focus();
      });
    });

    if (learnMoreClose) learnMoreClose.addEventListener('click', closeLearnMore);
    if (learnMoreOverlay) {
      learnMoreOverlay.addEventListener('click', function (e) {
        if (e.target === learnMoreOverlay) closeLearnMore();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLearnMore();
      trapFocus(e);
    });

    // ── Initialise states ─────────────────────────────────────────────────────
    rows.forEach(updateRowStyle);
    updateTotal();
    updateCta();

    // ── Gallery (Swiper) ──────────────────────────────────────────────────────
    var section = infoEl.closest('.product-template');
    initGallery(section);
  }

  function initGallery(section) {
    if (!section || typeof Swiper === 'undefined') return;

    var mainEl   = section.querySelector('.pdp-gallery-swiper--desktop');
    var thumbsEl = section.querySelector('.pdp-gallery-swiper--thumbs');
    var mobileEl = section.querySelector('.pdp-gallery-swiper--mobile');

    // Guard: skip if already initialised by app.js or a previous call
    if (mainEl && mainEl.swiper) return;

    var thumbsSwiper = null;
    if (thumbsEl && !thumbsEl.swiper) {
      thumbsSwiper = new Swiper(thumbsEl, {
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
      });
    } else if (thumbsEl && thumbsEl.swiper) {
      thumbsSwiper = thumbsEl.swiper;
    }

    if (mainEl) {
      new Swiper(mainEl, {
        spaceBetween: 10,
        navigation: {
          nextEl: section.querySelector('.pdp-swiper__next'),
          prevEl: section.querySelector('.pdp-swiper__prev'),
        },
        thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : {},
      });
    }

    if (mobileEl && !mobileEl.swiper) {
      new Swiper(mobileEl, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        freeMode: true,
        scrollbar: {
          el: mobileEl.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
      });
    }
  }

  // ── Boot ──────────────────────────────────────────────────────────────────
  function init() {
    document.querySelectorAll('.product-template-v3__info').forEach(initPdpV3);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
